import styled from 'styled-components';

// Main Section
const StyledMainWrapper = styled.div`
  min-height: 100%;
  position: relative;
  overflow: hidden;
`;

// Content Section
const StyledContentWrapper = styled.div`
  height: calc(100% - 64px);
  width: 100%;
  padding: 16px;
  margin-top: 64px;
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  background-color: ${(props) => props.theme.colors.white};
  scrollbar-width: thin !important; /* Scrollbar Firefox */
`;

// Title Page
const StyledTitle = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
`;

// Content Page
const StyledContent = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  /*margin-top: -16px;*/
`;

// Required Message
const StyledBoxRequired = styled.div`
  display: flex;
  flex: 1;
  margin: 8px;
  color: ${(props) => props.theme.colors.red};
  font-size: ${(props) => props.theme.typography.bodyText};
  font-weight: normal;
  line-height: 1.3;
  letter-spacing: 0.0175em;
`;

export const Layout = {
  MainWrapper: StyledMainWrapper,
  ContentWrapper: StyledContentWrapper,
  Title: StyledTitle,
  Content: StyledContent,
  BoxRequired: StyledBoxRequired,
};                